module.exports = __webpack_public_path__ + "img/profile.3d30e094.svg";